<div class="container">
    <div *ngIf="diagramItem != null; else NoImg">
        <a href="javascript:void(0)" class="img_container" (click)="open(mymodal1_img)">
            <img [src]="diagramPathLowRes" alt="" style="width: 100%" />
            <div class="middle" *ngIf="diagramPathHighRes">
                <div class="text"><i class="fa fa-search-plus" aria-hidden="true"></i></div>
            </div>
        </a>

        <!-- zoom in image -->
        <ng-template #mymodal1_img let-modal>
            <div class="modal-header pt-8 pb-8">
                <a
                    class="close-icon"
                    href="javascript:void()"
                    ngbAutofocus
                    (click)="modal.close('Ok click')"
                    style="top: 15px; right: 20px; position: absolute"
                >
                    <i class="flaticon2-cross"></i>
                </a>
            </div>
            <div class="modal-body output-lable">
                <img [src]="diagramPathHighRes" alt="" style="width: 100%; height: auto" />
            </div>
        </ng-template>
        <!-- zoom in image -->
    </div>
    <ng-template #NoImg>
        <h1 class="no-text">{{ 'STANDARD_FLANGE_PAGE.LABELS.DIAGRAM_INPUT.NOIMG' | transloco }}</h1>
    </ng-template>
</div>
